<template>
    <div class="text" ref="handle">
        {{txt}}
    </div>
</template>

<script>
    import { reactive, toRefs, computed, ref } from 'vue'

    //文字渐显特效
    export default {
        name: 'TextTransition3',
        props: {
            interval: { type: Number, default: () => 0 },
            txt: { type: String, default: () => '' }
        },
        setup: (props, context) => {
            const handle = ref()
            const state = reactive({
                props,
            })

            return {
                handle,
                ...toRefs(state),
            }
        },
        watch: {
            txt (newValue) {
            }
        },
        mounted () {
            this.timeId = setTimeout(() => {
                // document.getElementsByTagName('body')[0].style.setProperty('--text-transition2-color', 'black');
                //使用时可能已经销毁
                if (this.handle) {
                    this.handle.style.color = 'black'
                }
            }, this.props.interval)
        },
        unmounted () {
            clearTimeout(this.timeId)
        }
    }
</script>

<style scoped lang="scss">

    .text {
        position: relative;
        width: 20px;
        height: 20px;
        line-height: 20px;
        display: inline-block;
        color: #fff0;

        transition: color 1s linear;
    }
</style>